// ModalNuevaCategoria.js
import React, { useState } from "react";
import { toast } from "react-toastify";

import { ApiService } from "../ApiService";

export const ModalNuevaCategoria = ({ isOpen = true, onClose, onCategoryAdded, selectedSucursal }) => {
	const [nombreCategoria, setNombreCategoria] = useState("");
	const [descripcionCategoria, setDescripcionCategoria] = useState("");
	const [uploadState, setUploadState] = useState(false);
	const API_url = process.env.REACT_APP_API_URL;

	const [nombreCategoriaError, setNombreCategoriaError] = useState(false);
	const [descripcionCategoriaError, setDescripcionCategoriaError] = useState(false);

	if (!isOpen) return null;

	const handleSubmit = async (e) => {
		e.preventDefault();

		let hasError = false;

		// Validación del nombre de la categoría
		if (!nombreCategoria.trim()) {
			setNombreCategoriaError(true);
			toast.error("El nombre de la categoría es obligatorio", { position: "top-right" });
			hasError = true;
		} else {
			setNombreCategoriaError(false);
		}

		// Si la descripción está vacía, asignar "Sin descripción"
		const descripcion = descripcionCategoria.trim() || "Sin descripción";

		if (hasError) return;

		setUploadState(true);

		const token = localStorage.getItem("token");
		if (!token) {
			toast.error("Error de sesión", { position: "top-right" });
			return;
		}

		const payload = {
			name: nombreCategoria,
			description: descripcion,
		};

		try {
			const url = `api/company/category/insert?key_branch=${selectedSucursal}`;
			const options = {
				method: "POST",
				body: JSON.stringify(payload),
			};

			const response = await ApiService.fetchData(url, options);

			if (response) {
				onCategoryAdded("category",{
					key_category: response?.key_category ?? 0,
					name: nombreCategoria
				});
				toast.success(response?.message ?? "Categoría agregada con éxito");
				setNombreCategoria("");
				setDescripcionCategoria("");
				onClose();
			}
		} catch (error) {
			toast.error("Error al conectar al servidor", { position: "top-right" });
		} finally {
			setUploadState(false);
		}
	};

	return (
		<div className="modal-overlay-old">
			<div className="modal-container-old">
				<div className="modal-header-old">
					<h2 className="modal-title">Nueva Categoría</h2>
					<button className="close-modal-btn" onClick={onClose}>
						✖
					</button>
				</div>

				<form onSubmit={handleSubmit}>
					<div className="modal-body">
						<div className="form-group">
							<label className="txt-name-category" htmlFor="categoriaNombre">
								Nombre de la categoría:<span className="obligate">*</span>
							</label>
							<input
								className={`modal-input-old ${nombreCategoriaError ? "input-error" : ""}`}
								type="text"
								id="categoriaNombre"
								name="categoriaNombre"
								placeholder="Ingrese el nombre de la categoría"
								value={nombreCategoria}
								onChange={(e) => setNombreCategoria(e.target.value)}
							/>
						</div>

						<div className="form-group">
							<label className="txt-name-category" htmlFor="categoriaDescripcion">
								Descripción:
							</label>
							<input
								className={`modal-input-old ${descripcionCategoriaError ? "input-error" : ""}`}
								type="text"
								id="categoriaDescripcion"
								name="categoriaDescripcion"
								placeholder="Ingrese una descripción"
								value={descripcionCategoria}
								onChange={(e) => setDescripcionCategoria(e.target.value)}
							/>
						</div>
					</div>

					<div className="modal-footer">
						<button type="button" className="cancel-button-product"
							onClick={onClose}
						>
							Cancelar
						</button>
						<button type="submit" className="save-button"
							disabled={uploadState}
							style={{ opacity: uploadState ? '0.7' : '1' }}
						>
							{uploadState ? 'Subiendo...' : 'Guardar'}
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};
